module.exports = __webpack_public_path__ + "static/media/video-1.4a14f498.jpg";